export default "__VITE_ASSET__DYoZEQkb__"